import config from './config.js';
import { domReady } from './modules/utils.js';
import Reveal from './modules/reveal.js';

import './web-components/index.js';
import { set as mediaQuerySet } from './modules/media-queries.js';

if (config.mediaQueries) {
  mediaQuerySet(config.mediaQueries);
}

async function domInit() {
  await domReady();
  Reveal.init();
}

domInit();
